import axios from 'axios';
import objectToFormData from '@/utils/objectToFormData';

export async function getStyles() {
  return axios.get('/styles').then(response => response.data.styles || []);
}

export async function getMaterials(styleId) {
  return axios
    .get('/materials', {
      params: {
        sid: styleId,
      },
    })
    .then(response => response.data.materials);
}

export async function getProfiles(styleId, materialId) {
  const response = await axios.get('/profiles', {
    params: {
      sid: styleId,
      mid: materialId,
    },
  });
  const { profiles = [] } = response.data;
  return profiles;
}

export async function getWindowOpeningTypes(windowTypeId) {
  const response = await axios.get('/windows', {
    params: {
      gid: windowTypeId,
    },
  });
  const { windows = [] } = response.data;
  return windows;
}

export async function getWindowTypes(profileId) {
  const response = await axios.get('/wgroups', {
    params: {
      pid: profileId,
    },
  });
  const { groups = [] } = response.data;
  return groups;
}

export async function getSafetyTypes(profileId) {
  const response = await axios.get('/safety', {
    params: {
      pid: profileId,
    },
  });
  const { safety = [] } = response.data;
  return safety;
}

export async function getInnerColorGroups(profileId) {
  const response = await axios.get('/colors/inner', {
    params: {
      pid: profileId,
    },
  });
  const { groups = [] } = response.data;
  return groups;
}

export async function getOuterColorGroups(profileId) {
  const response = await axios.get('/colors/outer', {
    params: {
      pid: profileId,
    },
  });
  const { groups = [] } = response.data;
  return groups;
}

export async function getInnovations(profileId) {
  const response = await axios.get('/innovations', {
    params: {
      pid: profileId,
    },
  });
  const { innovations = [] } = response.data;
  return innovations;
}

export async function getStaticPagesList() {
  const response = await axios.get('/staticpages');
  const { pages = [] } = response.data;
  return pages;
}

export async function getStaticPage(id) {
  const response = await axios.get('/staticpages/get', { params: { pid: id } });
  return response.data;
}

export async function getCompanyInfo() {
  const response = await axios.get('/company');
  const { company = {} } = response.data;
  return company;
}

export async function getRanges(profileId, openingTypeId) {
  const response = await axios.get('/ranges', {
    params: {
      wid: openingTypeId,
      pid: profileId,
    },
  });
  const { ranges = [] } = response.data;
  return ranges;
}

export async function uploadFile(file, onUploadProgress) {
  const formData = new FormData();
  formData.append('file_dropzone', file);

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: ev => {
      const percentage = Math.round((ev.loaded * 100) / ev.total);
      if (typeof onUploadProgress === 'function') {
        onUploadProgress(percentage);
      }
    },
  };

  const response = await axios.post('/filehandler', formData, config);

  return response.data;
}

export async function postOfferQuote(data) {
  const formData = objectToFormData(data);

  const result = await axios.post('/offers/create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return result;
}
